const user = {
  state: {
    userInfo: null,
    classInfo: null
  },
  actions: {
    setUserInfo: function (context, userInfo) {
      context.state.userInfo = userInfo
    },
    setClassInfo: function (context, classInfo) {
      context.state.classInfo = classInfo
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js